export default function Cross({ className }) {
  return (
    <svg className={`cross-icon ${className}`} viewBox="0 0 28 40" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M11 0h6v11h11v6H17v23h-6V17H0v-6h11z" />
    </svg>
  );
}
